import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiHome, FiArrowLeft } from 'react-icons/fi';
import { Basketball } from '@phosphor-icons/react';

/**
 * 404 Not Found 页面
 */
export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900/40 to-slate-950 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        {/* 404 大标题 */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-accent-soft to-accent">
            404
          </h1>
          <div className="mt-4 flex items-center justify-center gap-2">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-slate-500/40 to-transparent" />
            <Basketball size={36} weight="duotone" className="text-orange-500" />
            <div className="h-px flex-1 bg-gradient-to-r from-transparent via-slate-500/40 to-transparent" />
          </div>
        </div>

        {/* 错误信息 */}
        <div className="bg-surface/50 backdrop-blur-xl rounded-2xl p-8 border border-glass-border shadow-2xl">
          <h2 className="text-2xl font-bold text-white mb-3">
            {t('error.pageNotFound', '页面未找到')}
          </h2>
          <p className="text-gray-400 mb-8">
            {t('error.pageNotFoundDesc', '抱歉,您访问的页面不存在或已被移除')}
          </p>

          {/* 操作按钮 */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleGoBack}
              className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-surface-highlight hover:bg-surface-highlight/80 text-gray-300 hover:text-white rounded-xl transition-all duration-200 border border-glass-border"
            >
              <FiArrowLeft className="w-5 h-5" />
              <span className="font-medium">{t('common.goBack', '返回上页')}</span>
            </button>
            <button
              onClick={handleGoHome}
              className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-accent-strong to-accent hover:from-accent hover:to-accent-soft text-white rounded-xl transition-all duration-200 shadow-[0_10px_20px_rgba(8,12,18,0.35)]"
            >
              <FiHome className="w-5 h-5" />
              <span className="font-medium">{t('common.goHome', '返回首页')}</span>
            </button>
          </div>
        </div>

        {/* 底部提示 */}
        <p className="mt-6 text-sm text-gray-500">
          {t('error.needHelp', '需要帮助?')}
          {' '}
          <a href="/" className="text-accent hover:text-accent-soft underline">
            {t('common.contactSupport', '联系客服')}
          </a>
        </p>
      </div>
    </div>
  );
}
